<template>
  <Page>
    <template #deck>
      The latest products rocketing your way
    </template>
    <div class="container mx-auto py-16">
      <ProductGrid :products="products" />
    </div>
  </Page>
</template>

<script setup lang="ts">
const pageTitle: Ref<string> = ref("New Launches")

const query = gql`
  query {
    products(first: 12, sortKey: CREATED_AT) {
      nodes {
        title
        featuredImage {
          urlThumbnail: url(transform: { maxWidth: 450 })
        }
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
        }
        handle
        id
      }
    }
  }
`

const variables = { handle: "categories" }
const { data } = await useAsyncQuery("categories", { query, variables })

if (!data.value) navigateTo("/404")
const products = computed(() => data.value?.products?.nodes ?? [])

definePageMeta({
  title: "New Launches",
})

useHead({
  title: "New Launches",
})
</script>
